import React from "react";

import ProfilePhotoPickerV2 from "UIComponents/ProfilePhotoPickerV2";
import { ImageSquareOutlined } from "@toddle-edu/ds-icons";

import { useI18n } from "Hooks";

import { useChannelInfoOptions } from "./ChannelContext";

const ChannelProfileImage = ({ uploadStatus }) => {
  const { t } = useI18n(["common"]);

  const {
    channelProfileImage,
    handleChannelInfoChange,
  } = useChannelInfoOptions();

  const handleProfileImageUpdate = profileImage => {
    handleChannelInfoChange({ channelProfileImage: profileImage });
  };

  return (
    <>
      <div className="text-label">{t("common:channel_image")}</div>
      <ProfilePhotoPickerV2
        value={channelProfileImage}
        uploadStatus={uploadStatus}
        showButtonOnHover={true}
        icon={<ImageSquareOutlined />}
        updateInputField={handleProfileImageUpdate}
        text={t("common:add_image")}
        ratio="1:1"
      />
    </>
  );
};

export default ChannelProfileImage;
